import { Component, OnInit } from '@angular/core';
import { BookingService } from '../service/booking.service';
import { Booking } from '../booking';
import { Vademecum } from '../vademecum';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-edit-medical-info',
  templateUrl: './edit-medical-info.component.html',
  styleUrls: ['./edit-medical-info.component.css']
})
export class EditMedicalInfoComponent implements OnInit {

  booking!: Booking;
  vademecum!: Vademecum;
  healthProblems: string[] = [];

  constructor(
    private bookingService: BookingService,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    this.booking = this.bookingService.booking;
    if(this.booking){
      this.httpService.getVademecumByBookingId(this.booking.id!)
      .subscribe(vademecum => {
        this.vademecum = vademecum;
        this.extractHealthProblems(this.vademecum);
      });
    }
  }

  extractHealthProblems(doc: Vademecum){
    if(doc.hasAllergiesToMedicines){
      this.healthProblems.push("Allergies to medicines");
    }
    if(doc.hasAllergiesToSubstances){
      this.healthProblems.push("Allergies to substances");
    }
    if(doc.hasAsthma){
      this.healthProblems.push("Asthma");
    }
    if(doc.hasDiabetes){
      this.healthProblems.push("Diabetes");
    }
    if(doc.hasEpilepsy){
      this.healthProblems.push("Epilepsy");
    }
    if(doc.hasHeartTrouble){
      this.healthProblems.push("Heart trouble");
    }
    if(doc.hasMentalDisorder){
      this.healthProblems.push("Mental disorder");
    }
    if(doc.hasPhysicalDisability){
      this.healthProblems.push("Physical disability");
    }
    if(doc.hasRheumatism){
      this.healthProblems.push("Rheumatism");
    }
    if(doc.hasSkinAffection){
      this.healthProblems.push("Skin affection");
    }
    if(doc.hasSleepDisorder){
      this.healthProblems.push("Sleep disorder");
    }

  }

}
